const ShellBeComingRoundTheMountain = [
	'[Verse 1]',
	"She'll be coming 'round the mountain",
	'When she comes?',
	"She'll be coming 'round the mountain",
	'When she comes.',
	"She'll be coming 'round the mountain,",
	"She'll be coming 'round the mountain,",
	"She'll be coming 'round the mountain,",
	'When she comes.',
	'',
	'[Verse 2]',
	"She'll be driving six white horses",
	'When she comes',
	"She'll be driving six white horses",
	'When she comes',
	"She'll be driving six white horses",
	"She'll be driving six white horses",
	"She'll be driving six white horses",
	'When she comes',
	'',
	'[Verse 3]',
	"Oh, we'll all come out to meet her",
	'When she comes',
	"Oh, we'll all come out to meet her",
	'When she comes',
	"Oh, we'll all come out to meet her",
	"Oh, we'll all come out to meet her",
	"Oh, we'll all come out to meet her",
	'When she comes',
	'',
	'[Verse 4]',
	'We will kill the old red rooster',
	'When she comes',
	'We will kill the old red rooster',
	'When she comes',
	'We will kill the old red rooster',
	'We will kill the old red rooster',
	'We will kill the old red rooster',
	'When she comes',
	'',
	'[Verse 5]',
	"We'll all have chicken n' dumplin's",
	'When she comes',
	"We'll all have chicken n' dumplin's",
	'When she comes',
	"We'll all have chicken n' dumplin's",
	"We'll all have chicken n' dumplin's",
	"We'll all have chicken n' dumplin's",
	'When she comes',
];

export default ShellBeComingRoundTheMountain;
